import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraActionList, SpecraButton, SpecraEmptyState, SpecraIconButton, SpecraInlineBanner, SpecraLink, SpecraSectionHeader, SpecraSpinner } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { Unlink } from 'lucide-react';
import { useState } from 'react';
import { renderRouterLink } from '../../../lib/renderRouterLink';
import { registryHref } from '../registryHref';
import { useCapabilityLinkMutations, useCapabilityLinks } from './hooks';
import { LinkRequirementDialog } from './LinkRequirementDialog';
export function CapabilityLinksSection({ capabilityId }) {
    const query = useCapabilityLinks(capabilityId);
    const { unlink } = useCapabilityLinkMutations();
    const [open, setOpen] = useState(false);
    const canLink = query.data?.canLink === true && !query.isError;
    const links = query.data?.links ?? [];
    return /*#__PURE__*/ _jsxs("section", {
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                variant: "group",
                title: "Asked for in",
                action: canLink && /*#__PURE__*/ _jsx(SpecraButton, {
                    variant: "ghost",
                    size: "xs",
                    "data-testid": Testids.registryCapabilities.linkQuestion,
                    onClick: ()=>setOpen(true),
                    children: "Link a question"
                })
            }),
            query.isPending ? /*#__PURE__*/ _jsx(SpecraSpinner, {
                label: "Loading questions"
            }) : query.isError ? /*#__PURE__*/ _jsx(SpecraInlineBanner, {
                tone: "danger",
                action: /*#__PURE__*/ _jsx(SpecraButton, {
                    variant: "ghost",
                    onClick: ()=>void query.refetch(),
                    children: "Retry loading questions"
                }),
                children: "Could not load questions."
            }) : links.length ? /*#__PURE__*/ _jsx(SpecraActionList, {
                renderLink: renderRouterLink,
                items: links.map((l)=>({
                        id: l.id,
                        label: /*#__PURE__*/ _jsx(SpecraLink, {
                            href: l.askedForIn?.context ? registryHref(l.askedForIn.context) ?? undefined : undefined,
                            renderLink: renderRouterLink,
                            children: l.askedForIn?.label || 'Question or requirement'
                        }),
                        description: [
                            l.askedForIn?.contextName,
                            l.askedForIn?.excerpt
                        ].filter(Boolean).join(' · '),
                        actions: canLink ? /*#__PURE__*/ _jsx(SpecraIconButton, {
                            label: `Unlink ${l.askedForIn?.label || 'question'}`,
                            variant: "ghost",
                            size: "sm",
                            "data-testid": Testids.registryCapabilities.unlink,
                            disabled: unlink.isPending,
                            onClick: ()=>unlink.mutate(l.id),
                            children: /*#__PURE__*/ _jsx(Unlink, {})
                        }) : undefined
                    }))
            }) : /*#__PURE__*/ _jsx(SpecraEmptyState, {
                size: "compact",
                title: "Not linked to any question yet."
            }),
            unlink.isError && /*#__PURE__*/ _jsx(SpecraInlineBanner, {
                tone: "danger",
                children: "Could not unlink question. Try again using Unlink."
            }),
            open && canLink && /*#__PURE__*/ _jsx(LinkRequirementDialog, {
                open: true,
                onOpenChange: setOpen,
                capabilityId: capabilityId
            })
        ]
    });
}
